import { useDispatch, useSelector } from "react-redux";
import { updateFilter } from "../../actions";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import store from "store";
import Icon from "@identitybuilding/idb-react-iconlib";
import { Search } from "@identitybuilding/idb-react-iconlib/lib";

const SearchFilter = ({ props, page, noLocation, loading, hadsearched }) => {
  const dispatch = useDispatch();
  let { lang, translate } = useSelector((state) => state.general);
  let { serviceFilter } = useSelector((state) => state.search);
  let [filters, setFilters] = useState(false);
  let [facilities, setFacilities] = useState([]);
  // let [searchFacilities, setSearchFacilities] = useState([])
  let path = useSelector((state) => state.general.search_path);
  let search = useSelector((state) => state.search);
  let categoryID = useSelector((state) => state.search.categoryID);
  const keyboard = store.get("vkb");
  let [isLoading, setIsLoading] = useState(false);

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let params = useQuery().get("service");
  let urlItems = "";
  if (params) {
    urlItems = params.split(",");
  }
  const getFacilities = useCallback(
    async (test) => {
      let isMounted = true; // Flag to track if the component is mounted
      setIsLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_MEDIA_URL}/core/api/filters/?lang=${lang}`
        );
        if (isMounted) {
          let new_facilities = res.data.facilities.map((facility) => ({
            code: facility.id,
            icon: facility.icon,
            name: facility.name,
            active: test && test.includes(facility.id.toString()),
          }));
          setFacilities(new_facilities);
        }
      } catch (error) {
        console.error("Error fetching facilities:", error);
      } finally {
        if (isMounted) setIsLoading(false); // Stop loading spinner
      }

      return () => {
        isMounted = false; // Cleanup flag when component unmounts
      };
    },
    [lang]
  );


  let copy_search_facilities = serviceFilter;
  // if (typeof serviceFilter !== "string") {
  //   for (let i = 0; i < serviceFilter.length; i++) {
  //     copy_search_facilities.push(Number(serviceFilter[i]));
  //   }
  // }
  useEffect(() => {
    getFacilities(serviceFilter);
  }, []);

  useEffect(() => {
    if (!page || page !== "results") {
      const timeout1 = setTimeout(() => {
        setFilters(true);
      }, 500);

      const timeout2 = setTimeout(() => {
        setFilters(false);
      }, 4000);

      return () => {
        clearTimeout(timeout1);
        clearTimeout(timeout2); // Cleanup timeouts
      };
    }
  }, [page]);


  const checkBoxHandler = (index) => {
    let updatedFacilities = [...facilities];
    updatedFacilities[index].active = !updatedFacilities[index].active;
    setFacilities(updatedFacilities);

    let updatedFilters = updatedFacilities
      .filter((facility) => facility.active)
      .map((facility) => facility.code.toString());

    dispatch(updateFilter(updatedFilters));
  };


  return (
    <div
      className={`searchOptions filter ${page}  ${filters ? "active" : ""}`}
      style={{ animation: "searchFilters 0.5s" }}
    >
      <span className="so_btn" onClick={() => !filters && setFilters(!filters)}>
        <span id="filterTitle" onClick={() => setFilters(!filters)}>
          {translate("search_filters")}{" "}
          {facilities.length > 0 &&
            serviceFilter.length + "/" + facilities.length}
          {filters && <Icon name="Close" />}
        </span>

        <div className={`filtersMainWrapper ${filters ? "active" : ""}`}>
          {isLoading ? (
            <div className="loadingScreen">
              <Icon name="Loading" animated />
            </div>
          ) : (
            <>
              <div className={`filterWrapper`}>
                {/* Get the first 5 facilities */}
                {facilities.length > 0 &&
                  facilities.slice(0, 5).map((facility, index) => (
                    <div
                      title={facility.name}
                      className={`searchFilter ${facility.active ? "active" : ""}`}
                      key={index}
                      onClick={() => checkBoxHandler(index)}
                    >
                      <div className="icon">
                        {facility.icon && (
                          <div className="svg">
                            <img
                              src={facility.icon}
                              alt={facility.name}
                              width="26px"
                              height="26px"
                              className="img_servicefilters"
                            />
                          </div>
                        )}
                      </div>
                      <span>{facility.name} </span>
                    </div>
                  ))}
              </div>
              <div className={`filterWrapper second`}>
                {/* Then, get the other set of 5 */}
                {facilities.length > 0 &&
                  facilities.slice(5, 10).map((facility, index) => (
                    // We do index + 5 because we start at the fifth item
                    <div
                      title={facility.name}
                      className={`searchFilter ${facility.active ? "active" : ""}`}
                      key={index}
                      onClick={() => checkBoxHandler(index + 5)}
                    >
                      <div className="icon">
                        {facility.icon && (
                          <div className="svg">
                            <img
                              src={facility.icon}
                              alt={facility.name}
                              width="26px"
                              height="26px"
                              className="img_servicefilters"
                            />
                          </div>
                        )}
                      </div>
                      <span>{facility.name} </span>
                    </div>
                  ))}
              </div>
            </>
          )}
          {search.location.length > 0 ? (
            !loading ? (
              <Link
                id="filterSearchButton"
                to={
                  search.location.length > 0 &&
                  path(
                    encodeURIComponent(search.location.map((loc) => loc.slug).join(",")), // Join and encode municipalities
                    search.keyword_value || "", // Provide fallback for keyword
                    1, // Pagination
                    keyboard || "", // Ensure keyboard is defined
                    categoryID || "", // Fallback for categoryID
                    serviceFilter || "" // Ensure serviceFilter is passed
                  )

                }
                onClick={(e) => {
                  setFilters(false);
                  getFacilities(serviceFilter);
                }}
              >
                {translate("search_with_filters")}
              </Link>
            ) : (
              <div id="filterSearchButton" onClick={() => hadsearched(true)}>
                {translate("search_with_filters")}
              </div>
            )
          ) : (
            // <a
            //     id='filterSearchButton'
            //     href={search.location.length > 0 && path(search.location[0] && search.location[0].slug, search.keyword_value, 1, keyboard, categoryID && categoryID, serviceFilter)}
            //     onClick={(e) => setFilters(false)}
            // >
            //    {translate('search_with_filters')}
            //             </a>
            <span
              id="filterSearchButton"
              className="inactive"
              onClick={(e) => noLocation(e)}
            >
              {translate("search_with_filters")}
            </span>
          )}
        </div>
      </span>
    </div>
  );
};

export default SearchFilter;
